import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'charDaystring'
})
export class CharDaystringPipe implements PipeTransform {

  transform(value: string): string {

    var dayName = "";
    
    switch (value) {
      case 'L': dayName = 'Lunes'; break;
      case 'M': dayName = 'Martes'; break;
      case 'W': dayName = 'Miércoles'; break;
      case 'J': dayName = 'Jueves'; break;
      case 'V': dayName = 'Viernes'; break;
      case 'S': dayName = 'Sábado'; break;
      case 'D': dayName = 'Domingo'; break;
    }

    return dayName;
  }
}
